export default __webpack_public_path__ + "static/media/ChaseIO_FrontBody.52711c42.jpg";